import React from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import ChatPopup from "./ChatPopup";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { LocationOn, Phone, Email, AccessTime } from '@mui/icons-material';
import Footer from './Footer';
import { motion } from 'framer-motion';

function Locations() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const location = {
    city: "Hyderabad",
    address: "Madhura Nagar, Hyderabad, Telangana",
    phone: "+91 90590 81892",
    email: "info@sintechsolutions.com",
    hours: "Mon-Fri: 9:00 AM - 5:00 PM IST",
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        position: "relative",
      }}
    >
      <TopNavbar />
      <SecondNav />

      {/* Background Section */}
      <Box
        sx={{
          minHeight: '100vh',
          backgroundImage: 'url(https://media.istockphoto.com/id/953587268/photo/man-sitting-in-car-and-texting-on-the-phone-stock-image.jpg?s=612x612&w=0&k=20&c=uW7ZNjg1uOeyqN9MlJMUnfziNLMk9HkLNp9G40wdW4s=)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'relative',
          zIndex: 1,
          '&::before': {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))",
            zIndex: -1,
          },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
          mt: 4,
        }}
      >
        {/* Hero Title */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 'bold',
                color: '#fff',
                textShadow: '0 4px 8px rgba(0,0,0,0.5)',
                fontSize: { xs: '2.5rem', md: '4rem' },
                background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Our Location
            </Typography>
          </motion.div>
        </Box>

        {/* Card Section */}
        <Container maxWidth="xl">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 1.5 } },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                px: 2,
              }}
            >
              <motion.div
                variants={cardVariants}
                whileHover={{ scale: 1.02, boxShadow: '0 12px 40px rgba(0,0,0,0.4)' }}
                transition={{ duration: 0.3 }}
                style={{ width: '100%', maxWidth: '1000px' }}
              >
                {/* Card Top */}
                {/* <Box
                  sx={{
                    height: '140px',
                    background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                    borderRadius: '12px 12px 0 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0.85,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: '#fff',
                      color: '#1E88E5',
                      fontWeight: '700',
                      '&:hover': { backgroundColor: '#f0f0f0' },
                    }}
                  >
                    View on Map
                  </Button>
                </Box> */}
                <Box
  sx={{
    height: '140px',
    background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
    borderRadius: '12px 12px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.85,
  }}
>
  <a
    href="https://www.google.com/maps/place/Hyderabad,+Telangana/@17.4127332,78.0783688,10z/data=!3m1!4b1!4m6!3m5!1s0x3bcb99daeaebd2c7:0xae93b78392bafbc2!8m2!3d17.406498!4d78.4772439!16zL20vMDljNnc?entry=ttu&g_ep=EgoyMDI1MDYwMy4wIKXMDSoASAFQAw%3D%3D"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none' }}
  >
    <Button
      variant="contained"
      sx={{
        backgroundColor: '#fff',
        color: '#1E88E5',
        fontWeight: '700',
        '&:hover': { backgroundColor: '#f0f0f0' },
      }}
    >
      View on Map
    </Button>
  </a>
</Box>


                {/* Info Card */}
                <Card
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(12px)',
                    borderRadius: '0 0 12px 12px',
                    boxShadow: '0 10px 35px rgba(0,0,0,0.35)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderTop: 'none',
                    px:1,
                  }}
                >
                  <CardContent
                    sx={{
                     
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      minHeight: '300px',
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 'bold',
                        color: '#fff',
                        mb: 4,
                        background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                      }}
                    >
                      {location.city}
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <LocationOn sx={{ color: '#1E88E5', mr: 1 }} />
                      <Typography sx={{ color: '#ddd' }}>{location.address}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Phone sx={{ color: '#1E88E5', mr: 1 }} />
                      <Typography sx={{ color: '#ddd' }}>{location.phone}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Email sx={{ color: '#1E88E5', mr: 1 }} />
                      <Typography sx={{ color: '#ddd' }}>{location.email}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <AccessTime sx={{ color: '#1E88E5', mr: 1 }} />
                      <Typography sx={{ color: '#ddd' }}>{location.hours}</Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Box>
          </motion.div>
        </Container>
      </Box>

      <ChatPopup />
      <Footer />
    </div>
  );
}

export default Locations;
